export const allowPermission = (key: any, data: any) => {
    return data?.find((item: any) => item?.key === key) ? true : false;
};
